import AvailableRoutes from "@/components/routes/AvailableRoutes";
import useLearningRoutes from "@/context/routes/hook";

const RoutesScreen = () => {
  const { routesList, loadingRoutes } = useLearningRoutes();
  return (
    <AvailableRoutes routes={routesList} loading={loadingRoutes} />
  );
};

export default RoutesScreen;
